import styled from 'styled-components/macro'

export const FormBody = styled.form`
  padding: 16px 20px;
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
`

export const Row = styled.div`
  display: grid;
  grid-template-columns: 160px 1fr;
  gap: 12px;
  align-items: center;
`

export const Label = styled.label`
  font-size: 13px;
  color: #333;
`

export const Input = styled.input`
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  outline: none;
  &:focus {
    border-color: #999;
  }
  &::placeholder {
    color: #aaa;
  }
`

export const Textarea = styled.textarea`
  width: 100%;
  min-height: 100px;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  outline: none;
  resize: vertical;
  &:focus {
    border-color: #999;
  }
  &::placeholder {
    color: #aaa;
  }
`

export const Select = styled.select`
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  outline: none;
  background: #fff;
  &:focus {
    border-color: #999;
  }
`
